var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 65,
    viewBox: "0 0 63 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0312 16.3203V18.5603C36.0312 19.4564 36.0312 19.9044 35.8678 20.2467C35.7239 20.5478 35.4945 20.7925 35.2122 20.9459C34.8914 21.1203 34.4713 21.1203 33.6312 21.1203H29.4312C28.5912 21.1203 28.1711 21.1203 27.8503 20.9459C27.568 20.7925 27.3386 20.5478 27.1947 20.2467C27.0313 19.9044 27.0312 19.4564 27.0312 18.5603V16.3203M25.8312 48.3203H37.2313C38.9114 48.3203 39.7515 48.3203 40.3932 47.9715C40.9577 47.6647 41.4166 47.1752 41.7043 46.5731C42.0312 45.8886 42.0312 44.9925 42.0312 43.2003V21.4403C42.0312 19.6481 42.0312 18.7521 41.7043 18.0675C41.4166 17.4654 40.9577 16.9759 40.3932 16.6691C39.7515 16.3203 38.9114 16.3203 37.2313 16.3203H25.8313C24.1511 16.3203 23.311 16.3203 22.6693 16.6691C22.1048 16.9759 21.6459 17.4654 21.3582 18.0675C21.0312 18.7521 21.0312 19.6481 21.0312 21.4403V43.2003C21.0312 44.9925 21.0312 45.8886 21.3582 46.5731C21.6459 47.1752 22.1048 47.6647 22.6693 47.9715C23.311 48.3203 24.1511 48.3203 25.8312 48.3203Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.a967eecd081111a3c0ce32aa900884b3.svg";
export { ForwardRef as ReactComponent };